var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0_82_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_82_9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_82_9",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_82_9",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADYklEQVRYCe1X7XHbMAzVCNmgGSEbJBu0GwRSB4g3cDZINnA38AgZQb9yNsm0GkF/epeU0J3aBxIWxUiqHf9N7nyURBAfj8ADUhSff0cgQHV/gd8RoiJCzevlKfKLeivH29JyH391+dLdzh2oDN+XtmtUvrL8MCd71HdyflUa35SOr/Ej221KAwO+od3rpSoh66+i4ZYMr/Eu3xy35HitcievpeOarL9LD9KuvxRHgIrpbivrqQyGtjnsMF4artPzJz0LlI6vpw4hUoUaz5MyL903yEztHfVt2YGgXGTMdF6Q45vzHdh3X3NvcQ0CO+47INHSs796J3e+A13zLgfq/gIJR9Zv1GBp/A9JzKxU6ae/OysHkGyV4S0UoaSkJB23AvtQmlqiPZz4Vy1PkJUzjrdkeKuOHr3i7qoXvwHMMEamawh8YLjWO9fS1JX2foU9cVhklQ98U1m/gc7/OiBJ4/hJjFp+AvzyvAuHA/Tz5EKOH/QqAjdwDx3ivCDmm6lcEccCi8mBTUoyJRxxvJZ9MxCQoiRwR1Kipr+InLCuhLQGDkj5A7pGaETjLeAcbRRFIYlkcRVdA+LBvlRBlgMUUaKdpzKTT3VCTpzcv60O31Plh4/xQaMCJetegPrQHyQJx1UBZwe09JyuGpS+F+JRRrm6KQ5Ig0kcALw5AknjkYAstzk1H3SCvpOAipjBbXr3uXAKm8CYO6B5EJVrLqgeXWOiS9PSb7IqtyMfUkdQ14BXGksSVUgqfsCe5g4ilkoBQ6IR2XESSmJKWU/3jkISSNot91K7iAYHnn9fyVWYrlnq8VopiChcHTjkzz2C0NJWZ0fR5y9wZKhdSbYaLKjDCe3fVoBy9IvOomyFxIbBpE1Rym0tvsMgHFEyISuRLFAxt2RlhtjoGTi0aGRpc3IgAdnIVXRDM7L8OFV2FFBpl2ws7kmpTZFTbMe480hioNzZdjxXjovGsTnnAPbIDAMJ7cdjmyrWfvD9V/9Fv520igMTAwmUVBhYIxcAhSnFUvPnjWTShkfzXqh1foRxRB65P5RtMinDIaHcc4bSQCYes8AN/tmQ+8aMEEd1jVqaUxzXIQPoQ/RdM3c9enZxBZkcRnAdTMBy2eilSlIiE4TcB6YhVZauMHhKIkF+zslU7+czEPgLu+VYxU8daVMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactJs);
export default __webpack_public_path__ + "static/media/react-js.bbe360b39047735504002632e61a8bad.svg";
export { ForwardRef as ReactComponent };